export default __webpack_public_path__ + "static/media/milk bottle.06db1729.png";